import { useRoot } from '-app/root'

export function useNotificationsModel() {
  const { notifications } = useRoot()

  return notifications
}
